import Player from '@vimeo/player';

export default () => ({
  muted: true,
  firstPlay: true,

  muteToggle() {
    var vimeoPlayer = new Player('vimeoPlayer');
    if (this.muted) {
      vimeoPlayer.setVolume(1);
      this.muted = false;
      if (this.firstPlay) {
        vimeoPlayer.setCurrentTime(0);
        this.firstPlay = false;
      }
    } else {
      vimeoPlayer.setVolume(0);
      this.muted = true;
    }
  },

  playVideo() {
    var vimeoPlayer = new Player('vimeoPlayer');
    if (this.muted) {
      vimeoPlayer.setVolume(1);
      this.muted = false;
      if (this.firstPlay) {
        vimeoPlayer.setCurrentTime(0);
        this.firstPlay = false;
      }
    }
  },

  init() {},
});
